import React from "react";
import Chart from "react-apexcharts";
import { getUserDisplayName } from "src/Utils/Common";

const DonutChart = ({title, dataValues, labels, chartOptions}) => {
  const options = {
    chart: {
      type: "donut",
    },
    colors: ["#08306B", "#21A0FF"],
    labels: labels ? labels[0].labels : ["Market", getUserDisplayName()],
    title: {
      text: title,
      align: "center",
      style: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    legend: {
      position: "bottom",
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "13px", // You can reduce this to something like "8px" if needed
      },
      formatter: (val) => `${val.toFixed(1)}%`,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "20%", // Wider colored section (smaller hole)
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };
  

  return dataValues && dataValues.length > 0 ? (
  <Chart
    options={chartOptions || options}
    series={dataValues[0].data}
    type="donut"
    width="100%"
  />
) : null;
};

export default DonutChart;
